import React from 'react';
import { Drawer, Typography, Space, List, Button } from 'antd';
import gridIcon from '../../../../assets/DasboardIcons/grid.png';
import slidesIcon from '../../../../assets/DasboardIcons/slides.svg';
import boardIcon from '../../../../assets/DasboardIcons/board.png';
import mindmapIcon from '../../../../assets/DasboardIcons/mindmap.svg';
import ideationIcon from '../../../../assets/DasboardIcons/ideation.svg';
import spacesIcon from '../../../../assets/DasboardIcons/spaces.svg';
import moodIcon from '../../../../assets/DasboardIcons/mood.png';
import WorkWsieIcon from '../../../../components/ResultComponent/WorkWsieIcon';

const ApplicationsDrawer = ({ open, onClose }) => {

  
  const appUrls = {
    grid: 'https://grid.workw.com/',
    slides: 'https://slides.workw.com/',
    board: 'https://board.workw.com/',
    mindmap: 'https://map.workw.com/',
    spaces: 'https://spaces.workw.com/',
    ideation: 'https://ideation.workw.com/',
    mood: 'https://mood.workw.com/',
  };
  
  const handleAppClick = (id) => {
    const url = appUrls[id];
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  
  const customTitle = (
    <Space align="center" size={8}>
      <WorkWsieIcon width="80" height="40" logoOnly={false} textColor='#000'/>
      <Typography.Text style={{ fontSize: 24, fontWeight: 300, color: 'rgba(0,0,0,0.88)' }}>
        Pad
      </Typography.Text>
    </Space>
  );

  const items = [
    { id: 'grid', name: 'Grid', icon: gridIcon },
    { id: 'slides', name: 'Slides', icon: slidesIcon },
    { id: 'board', name: 'Board', icon: boardIcon },
    { id: 'mindmap', name: 'Mindmap', icon: mindmapIcon },
    { id: 'ideation', name: 'Ideation', icon: ideationIcon },
    { id: 'mood', name: 'Mood', icon: moodIcon },
    { id: 'spaces', name: 'Spaces', icon: spacesIcon },
  ];

  return (
    <Drawer
      title={customTitle}
      placement="left"
      onClose={onClose}
      visible={open}
      closable={false}
      width={300}
      bodyStyle={{ padding: 16, background: 'white' }}
      zIndex={1050}
      mask={true}
      style={{ position: 'absolute' }}
      headerStyle={{ borderBottom: '1px solid #f0f0f0', paddingLeft: '10px' }}
    >
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <List
          dataSource={items}
          split
          renderItem={(item) => (
            <List.Item style={{ padding: 0, borderBlockEndColor: '#f4f4f4' }}>
              <Button
                key={item.id}
                type="text"
                block
                onClick={() => handleAppClick(item.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '10px 12px',
                  borderRadius: 8,
                  height: 'auto',
                  textAlign: 'left',
                }}
              >
                <img src={item.icon} alt={item.name} style={{ height: 24, width: 22, objectFit: 'contain' }} />
                <Typography.Text style={{ fontSize: 14, color: 'rgba(0,0,0,0.88)' }}>{item.name}</Typography.Text>
              </Button>
            </List.Item>
          )}
        />
      </Space>
    </Drawer>
  );
};

export default ApplicationsDrawer;